export const env = {
  release: window.location.origin.includes('localhost') ? false : true,
  base_api_url: (window.location.origin.includes('localhost') ? 'http://localhost:8081' : (window.location.origin+'/pms-api')),
  host: window.location.origin,
};